import { en } from './en'
import { fr } from './fr'

export const imageGalleryPage = {
  en,
  fr
}